import React from 'react';
import { OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  entranceUuid,
  hoverEffectUuid,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const Option = OriSelect.Option;

const EffectSelect = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, entranceEffectOptions, hoverEffectOptions } = props;

  return (
    <Section size='small' bottomBorder={false} style={{ paddingTop: '12px' }}>
      <ItemWrapper title={getI18n('salesChannelContent.index.entranceEffect')}>
        <Field name={entranceUuid}>
          <OriSelect
            disabled={disabled}
            size='large'
            //   value={moduleWidth}
            //   onChange={handleOnModuleWidthChange}
          >
            <Option value={null}>{getI18n('general.status.none')}</Option>
            {entranceEffectOptions.map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </OriSelect>
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.hoverEffect')}>
        <Field name={hoverEffectUuid}>
          <OriSelect
            disabled={disabled}
            size='large'
            //   value={moduleWidth}
            //   onChange={handleOnModuleWidthChange}
          >
            <Option value={null}>{getI18n('general.status.none')}</Option>
            {hoverEffectOptions.map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </OriSelect>
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default EffectSelect;
